"use strict";

declare var morningstar: any;
declare var loaderConfig: any;
declare var SALauthUrl: any;
declare var mapHoldingTypeIdToReportURL: any;
declare var _marketsApiToken: any;
declare var pathBase: string;
declare var $clamp: any;
declare var cssVars: any;
declare var Chart: any;
let apiGatewayToken = '';
Chart.defaults.LineWithLine = Chart.defaults.line;
Chart.defaults.global.defaultFontFamily = "'Neue Helvetica W01', 'sans-serif'";
Chart.controllers.LineWithLine = Chart.controllers.line.extend({
   draw: function(ease) {
      Chart.controllers.line.prototype.draw.call(this, ease);

      if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
         var activePoint = this.chart.tooltip._active[0],
             ctx = this.chart.ctx,
             x = activePoint.tooltipPosition().x,
             topY = this.chart.legend.bottom,
             bottomY = this.chart.chartArea.bottom;

         // draw line
         ctx.save();
         ctx.beginPath();
         ctx.moveTo(x, topY);
         ctx.lineTo(x, bottomY);
         ctx.lineWidth = 1;
         ctx.strokeStyle = '#333';
         ctx.setLineDash([5, 5]);
         ctx.stroke();
         ctx.restore();
      }
   }
});
//init css vars ponyfill
function rootMorningstarPromise() :any {

  return new Promise((resolve, reject) => {

      loaderConfig.apiTokens.apiGatewayToken = _marketsApiToken;

      console.log('initializing morningstar');
      //loads Morningstar
      morningstar.loader.load(loaderConfig).then(() => {
        resolve(); //returns a promise object
      })

  })
}
function fetchFromObject(obj, prop) {
  //property not found
  if (typeof obj === "undefined") return false;

  //index of next property split
  var _index = prop.indexOf(".");

  //property split found; recursive call
  if (_index > -1) {
    //get object at property (before split), pass on remainder
    return fetchFromObject(
      obj[prop.substring(0, _index)],
      prop.substr(_index + 1)
    );
  }

  //no split; get property
  return obj[prop];
}

function loadMarketsComponent(
  elementId,
  containerId,
  componentTagName,
  componentId
) {
  const container = document.createElement("div");
  var containerParent = document.getElementById(elementId);
  container.setAttribute("id", containerId);
  containerParent.appendChild(container);

  const marketsComponentSettings = fetchFromObject(
    loaderConfig.configuration.overrides.components,
    componentId + ".settings"
  );

  return new Promise(function (resolve, reject) {
    var component = morningstar.components[componentTagName];
    if(component){
      component.createComponent({
        element: container,
        initialConfiguration: {
          component: {
            configuration: marketsComponentSettings,
            id: containerId,
            callbacks: marketsComponentSettings.callbacks
          }
        }
      });
      resolve();
    }else{
      reject('Could not find component with tagname in morningstar components: ' + componentTagName)
    }
  });
}

var waitForEle = (element, callback) =>{
  var checkExist = setInterval(function () {
    if ($(element).length) {
      clearInterval(checkExist);
      callback()
    }
  }, 1000); // check every 100ms
}
var initComponent = function (elementId, containerId, componentTagName, componentId) {
  let count = 0;
  let maxRetries = 3;
  const init = function(element){
    var component = morningstar.asterix.instanceRegistry.find(componentId);
    if (component) {
      var path = component.modulePath
      var componentTag = document.createElement(componentTagName);
      var container = document.createElement('div');
      if (componentId.indexOf('ecWatchList') === -1 && !morningstar.asterix.instanceRegistry.find(componentId).isActive) {
        console.log('Destroying watchlist first..');
        morningstar.asterix.instanceRegistry.get(path).destroy();
      }

      morningstar.asterix.instanceRegistry.init(path);

      componentTag.setAttribute('mstar-component-id', componentId);
      // ... and attach it to the container.

      container.setAttribute('id', containerId);
      container.appendChild(componentTag);

      // Bootstrap the element
      angular.bootstrap(container, morningstar.asterix.ng.getAngularModuleDependencies());

      element.innerHTML = '';
      element.appendChild(container);
    } else {
      console.error("Could not find component with ID " + componentId)
    }
  }
  let promiseChain = new Promise(function (resolve) {
    waitForEle('#' + elementId, function(){
      var element = document.getElementById(elementId);
      init(element);
      resolve()
    })

  });

  if (loaderConfig.lazy.initializeMarketsComponent && componentTagName.indexOf('markets-') == 0) {
    promiseChain.then(function () { loadMarketsComponent(elementId, containerId, componentTagName, componentId); });
  }

  return promiseChain;
}

interface IAppRootScopeService extends angular.IRootScopeService {
  $state: any;
  $stateParams: any;
  layout: string;
  errorHandler: any;
  morningstarPromise:any;
  morningstarSalETFPromise: any;
  initComponent: any;
  getProfitLossClass: (number) => string;
}

// var morningstarDependencies = morningstar.asterix.ng.getAngularModuleDependencies();
var allDependencies = [
  "ui.router",
  "ui.router.state.events",
  "app.filters",
  "app.services",
  "app.directives",
  "app.components",
  "app.controllers",
  'ui.bootstrap',
  'ui.bootstrap.showErrors',
  'ui.bootstrap.modal',
  'validation.match',
  'app.identityModule',
  'app.portfolioModule',
  'app.analysisModule',
  'app.myDetailsModule',
  'app.researchModule',
  'app.accountDetailsModule',
  'app.changeRequestModule',
  'angular-smart-chartist',
  'ngSanitize',
  'ngCsv',
  'chart.js',
  // 'SALModule',
  
  'ngRoute',
  'duScroll',
  'ngTagsInput',
  
  //analytics
  "ApplicationInsightsModule",
  'angulartics',
  'angulartics.google.tagmanager'
];

var module = angular.module("app", allDependencies);

module.config([
  "$provide",
  "$stateProvider",
  "$locationProvider",
  "$httpProvider",
  "applicationInsightsServiceProvider",
  "showErrorsConfigProvider",
  '$compileProvider',
  '$analyticsProvider',
  function(
    $provide,
    $stateProvider,
    $locationProvider: angular.ILocationProvider,
    $httpProvider,
    applicationInsightsServiceProvider,
    showErrorsConfigProvider,
    $compileProvider,
    $analyticsProvider) {

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel):/);
    $locationProvider.html5Mode(true);
    $stateProvider
      .state("home",
        {
          url: "/",
          templateUrl: 'assets/templates/common/loading.html',
          controller: 'landingCtrl'
        })
      .state('help', {
        url: '/help',
        templateUrl: 'assets/templates/common/help.html',
        controller: "helpViewCtrl",
        resolve: {
          meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Help"};
          }],
        }
      })
      .state('forbidden', {
        url: '/forbidden',
        templateUrl: 'assets/templates/common/forbidden.html',
        resolve: {
          meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Forbidden"};
          }],
        }
      })
      .state('error', {
        url: '/error',
        templateUrl: 'assets/templates/common/error.html',
        resolve: {
          meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Error"};
          }],
        }
      })
      .state("otherwise",
        {
          url: "*path",
          templateUrl: "assets/templates/common/404.html",
          resolve: {
            meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "Not Found"};
            }],
          }
        });

    var model: string = document.getElementById("model").textContent.trim();
    //var trustedLoginMessage = $sceProvider.trustAsHtml(model['content']['loginMessage']);
    var dictionary: any = JSON.parse(model);

    var applicationInsightsInstrumentationKey = dictionary['applicationInsightsInstrumentationKey'];

    var options = { applicationName: 'Investor Website', autoPageViewTracking: true, autoLogTracking: false, autoExceptionTracking: true };
    applicationInsightsServiceProvider.configure(applicationInsightsInstrumentationKey, options);

    $provide.decorator("applicationInsightsService", ["tokenService", "$delegate", function myDecorate(tokenService, $delegate) {

      var original = $delegate.trackPageView;
      $delegate.trackPageView = function decoratedWarn(msg) {

        let propertyInfo: any = {};
        propertyInfo.ComponentName = "Investor Website";
        if (tokenService.tokenManager.profile) {

          propertyInfo.email = tokenService.tokenManager.profile.email;
          propertyInfo.account = tokenService.tokenManager.profile.account;
          //propertyInfo.agaccount = tokenService.tokenManager.profile.agaccount;
          propertyInfo.auth_time = new Date(tokenService.tokenManager.profile.auth_time * 1000);
          propertyInfo.given_name = tokenService.tokenManager.profile.given_name;
          propertyInfo.family_name = tokenService.tokenManager.profile.family_name;
          propertyInfo.pan = tokenService.tokenManager.profile.preferred_username;
          propertyInfo.role = tokenService.tokenManager.profile.role;
          propertyInfo.sub = tokenService.tokenManager.profile.sub;
          propertyInfo.sid = tokenService.tokenManager.profile.sid;
        }
        $delegate.setCommonProperties(propertyInfo);

        original.apply($delegate, arguments);
      };
      return $delegate;
    }]);

    $provide.decorator("$analytics", ["tokenService", "$delegate", (tokenService, $delegate) => {
      if (tokenService.tokenManager.profile) {
        $analyticsProvider.settings.ga = {
          userId: tokenService.tokenManager.profile.preferred_username
        };
      }
      return $delegate;
    }]);
    $analyticsProvider.excludeRoutes(['/callback', '/forbidden']);
    $analyticsProvider.withBase(false);
    $analyticsProvider.firstPageview(false);
    //handle page tracking manually to work around dynamic titles
    $analyticsProvider.virtualPageviews(false);
    
    showErrorsConfigProvider.showSuccess(true);

    $httpProvider.interceptors.push('bearerInjector');

  }]);

module.run([
  '$templateCache',
  '$rootScope',
  '$state',
  '$stateParams',
  '$http',
  'tokenService',
  'sessionService',
  '$analytics',
  '$location',
  'userCompanyService',
  function(
    $templateCache: ng.ITemplateCacheService,
    $rootScope: IAppRootScopeService,
    $state,
    $stateParams,
    $http,
    tokenService, 
    sessionService,
    $analytics,
    $location,
    userCompanyService) {
  console.log("Running App");

  // Allows to retrieve UI Router state information from inside templates
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.$on("$stateChangeError", console.log.bind(console));

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    
    $http.pendingRequests.forEach(function(request) {

      let url = request.url;
      let stringsToMatch = [
        "dataService/api/adviser",
        "dataService/odata/changeRequests/ChangeRequestService.GetChangeRequestsForApprovalCount",
        "dataService/api/userCompany",
        "dataService/api/Reporting/CheckFreezeWindow"
      ]  
      let match = false;
      stringsToMatch.forEach((string) => {
        if(!match && url.indexOf(string) > -1) {
          match = true
        }
      })
      //Check if the requests are within the nav bar or footer - if so do not cancel them 
      if(!match){
        if (request.cancel) {
          request.cancel.resolve();
        }
      }
    });

    console.log('destroying sal-report')
    //remove the SAL reports
    $('#sal-report').empty()


      $('#app').removeClass(function (index, className) {
        return (className.match(/(^|\s)page-\S+/g) || []).join(' ');
      });
      $('#app').addClass('page-' + toState.name)

  });
  //only track the page when title is resolved
  $rootScope.$on('$titleChangeSuccess', function(event, route) {
    $analytics.pageTrack($location.path());
  });

  //profit loss class
  $rootScope.getProfitLossClass = function(number) {
    let _class = "";
    const _number = parseFloat(number);
    if(!isNaN(_number)) {
      if(number === 0) {
        _class = "";
      }else if(_number > 0) {
        _class = "success";
      }else {
        _class = "danger";
      }
    }
    return _class;
  }
}]);
